import api from '@/social/API';
import { PostCategory } from '@/type';

export default {
  findAll(): Promise<PostCategory[]> {
    return api
      .get('post-categories')
      .then(response => response.data);
  },
};
